"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lineStringLength = lineStringLength;
exports.linearRingLength = linearRingLength;

/**
 * @module ol/geom/flat/length
 */

/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Length.
 */
function lineStringLength(flatCoordinates, offset, end, stride) {
  var x1 = flatCoordinates[offset];
  var y1 = flatCoordinates[offset + 1];
  var length = 0;

  for (var i = offset + stride; i < end; i += stride) {
    var x2 = flatCoordinates[i];
    var y2 = flatCoordinates[i + 1];
    length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    x1 = x2;
    y1 = y2;
  }

  return length;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Perimeter.
 */


function linearRingLength(flatCoordinates, offset, end, stride) {
  var perimeter = lineStringLength(flatCoordinates, offset, end, stride);
  var dx = flatCoordinates[end - stride] - flatCoordinates[offset];
  var dy = flatCoordinates[end - stride + 1] - flatCoordinates[offset + 1];
  perimeter += Math.sqrt(dx * dx + dy * dy);
  return perimeter;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFBQTs7OztBQUlBOzs7Ozs7O0FBT00sU0FBVUEsZ0JBQVYsQ0FBMkJDLGVBQTNCLEVBQTRDQyxNQUE1QyxFQUFvREMsR0FBcEQsRUFBeURDLE1BQXpELEVBQStEO0VBQ25FLElBQUlDLEVBQUUsR0FBR0osZUFBZSxDQUFDQyxNQUFELENBQXhCO0VBQ0EsSUFBSUksRUFBRSxHQUFHTCxlQUFlLENBQUNDLE1BQU0sR0FBRyxDQUFWLENBQXhCO0VBQ0EsSUFBSUssTUFBTSxHQUFHLENBQWI7O0VBQ0EsS0FBSyxJQUFJQyxDQUFDLEdBQUdOLE1BQU0sR0FBR0UsTUFBdEIsRUFBOEJJLENBQUMsR0FBR0wsR0FBbEMsRUFBdUNLLENBQUMsSUFBSUosTUFBNUMsRUFBb0Q7SUFDbEQsSUFBTUssRUFBRSxHQUFHUixlQUFlLENBQUNPLENBQUQsQ0FBMUI7SUFDQSxJQUFNRSxFQUFFLEdBQUdULGVBQWUsQ0FBQ08sQ0FBQyxHQUFHLENBQUwsQ0FBMUI7SUFDQUQsTUFBTSxJQUFJSSxJQUFJLENBQUNDLElBQUwsQ0FBVSxDQUFDSCxFQUFFLEdBQUdKLEVBQU4sS0FBYUksRUFBRSxHQUFHSixFQUFsQixJQUF3QixDQUFDSyxFQUFFLEdBQUdKLEVBQU4sS0FBYUksRUFBRSxHQUFHSixFQUFsQixDQUFsQyxDQUFWO0lBQ0FELEVBQUUsR0FBR0ksRUFBTDtJQUNBSCxFQUFFLEdBQUdJLEVBQUw7RUFDRDs7RUFDRCxPQUFPSCxNQUFQO0FBQ0Q7QUFFRDs7Ozs7Ozs7O0FBT00sU0FBVU0sZ0JBQVYsQ0FBMkJaLGVBQTNCLEVBQTRDQyxNQUE1QyxFQUFvREMsR0FBcEQsRUFBeURDLE1BQXpELEVBQStEO0VBQ25FLElBQUlVLFNBQVMsR0FBR2QsZ0JBQWdCLENBQUNDLGVBQUQsRUFBa0JDLE1BQWxCLEVBQTBCQyxHQUExQixFQUErQkMsTUFBL0IsQ0FBaEM7RUFDQSxJQUFNVyxFQUFFLEdBQUdkLGVBQWUsQ0FBQ0UsR0FBRyxHQUFHQyxNQUFQLENBQWYsR0FBZ0NILGVBQWUsQ0FBQ0MsTUFBRCxDQUExRDtFQUNBLElBQU1jLEVBQUUsR0FBR2YsZUFBZSxDQUFDRSxHQUFHLEdBQUdDLE1BQU4sR0FBZSxDQUFoQixDQUFmLEdBQW9DSCxlQUFlLENBQUNDLE1BQU0sR0FBRyxDQUFWLENBQTlEO0VBQ0FZLFNBQVMsSUFBSUgsSUFBSSxDQUFDQyxJQUFMLENBQVVHLEVBQUUsR0FBR0EsRUFBTCxHQUFVQyxFQUFFLEdBQUdBLEVBQXpCLENBQWI7RUFDQSxPQUFPRixTQUFQO0FBQ0QiLCJuYW1lcyI6WyJsaW5lU3RyaW5nTGVuZ3RoIiwiZmxhdENvb3JkaW5hdGVzIiwib2Zmc2V0IiwiZW5kIiwic3RyaWRlIiwieDEiLCJ5MSIsImxlbmd0aCIsImkiLCJ4MiIsInkyIiwiTWF0aCIsInNxcnQiLCJsaW5lYXJSaW5nTGVuZ3RoIiwicGVyaW1ldGVyIiwiZHgiLCJkeSJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZ2VvbS9mbGF0L2xlbmd0aC5qcyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==